import { lazy, Suspense } from 'react'

// Small apps - load eagerly (< 50KB each)
import About from './About/About'
import Products from './Products/Products'
import Terminal from './Terminal/Terminal'
import FileManager from './FileManager/FileManager'
import Calculator from './Calculator/Calculator'
import Notepad from './Notepad/Notepad'
import Contact from './Contact/Contact'
import Minesweeper from './Minesweeper/Minesweeper'
import WorldMap from './WorldMap/WorldMap'
import Solitaire from './Solitaire/Solitaire'

// Large apps - lazy load (> 100KB each)
const TradeWars = lazy(() => import('./TradeWars/TradeWars'))
const LORD = lazy(() => import('./LORD/LORD'))
const Zelda = lazy(() => import('./Zelda/Zelda'))
const OregonTrail = lazy(() => import('./OregonTrail/OregonTrail'))
const AIAssistant = lazy(() => import('./AIAssistant/AIAssistant'))
const Chess = lazy(() => import('./Chess/Chess'))

// Loading fallback for lazy-loaded apps
function AppLoading() {
  return (
    <div className="app-loading" style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      backgroundColor: '#000',
      color: '#0f0',
      fontFamily: 'monospace',
      fontSize: '14px',
    }}>
      Loading...
    </div>
  )
}

interface AppContentProps {
  appId: string
}

export function AppContent({ appId }: AppContentProps) {
  const renderApp = () => {
    switch (appId) {
      // Eagerly loaded apps
      case 'about':
        return <About />
      case 'products':
        return <Products />
      case 'terminal':
        return <Terminal />
      case 'filemanager':
        return <FileManager />
      case 'calculator':
        return <Calculator />
      case 'notepad':
        return <Notepad />
      case 'contact':
        return <Contact />
      case 'minesweeper':
        return <Minesweeper />
      case 'worldmap':
        return <WorldMap />
      case 'solitaire':
        return <Solitaire />
      // Lazy loaded apps
      case 'oregon-trail':
        return <OregonTrail />
      case 'tradewars':
        return <TradeWars />
      case 'ai-assistant':
        return <AIAssistant />
      case 'zelda':
        return <Zelda />
      case 'lord':
        return <LORD />
      case 'chess':
        return <Chess />
      default:
        return (
          <div className="app-not-found">
            <h2>Application Not Found</h2>
            <p>The application "{appId}" could not be loaded.</p>
          </div>
        )
    }
  }

  return (
    <Suspense fallback={<AppLoading />}>
      {renderApp()}
    </Suspense>
  )
}
